import React, { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../hooks/useAuth';
import useNotification from '../hooks/useNotification';
import ArchiveTable from '../components/archive/ArchiveTable';
import axiosInstance from '../api/Axios';
import { API_ENDPOINTS } from '../constants/api';

const Archive = () => {
  const { user } = useAuth();
  const { showError } = useNotification();
  const [archivetasks, setArchivetasks] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchArchivedTasks = useCallback(async () => {
    try {
      const archivetasksResponse = await axiosInstance.get(API_ENDPOINTS.GET_ARCHIVE_TASKS);
      setArchivetasks(archivetasksResponse.data);
    } catch (error) {
      console.error("Error fetching archived tasks:", error);
      showError('Ошибка при загрузке архива');
    } finally {
      setIsLoading(false);
    }
  }, [showError]);

  useEffect(() => {
    fetchArchivedTasks();
  }, [fetchArchivedTasks]);

  if (isLoading) {
    return (
      <div className="flex-1 ml-20 flex items-center justify-center bg-gray-200 min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="flex-1 ml-20 p-6 bg-gray-200 min-h-screen">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900">Архив задач</h1>
          {user?.role !== 'admin' && (
            <p className="text-gray-600 mt-2">
              Вы видите только свои задачи в архиве
            </p>
          )}
          <p className="text-sm text-blue-600 mt-2">
            ⏰ Все времена отображаются в вашем локальном часовом поясе
          </p>
        </div>
        <ArchiveTable tasks={archivetasks} />
      </div>
    </div>
  );
};

export default Archive;
